import { Link } from "react-router-dom";
import artemis_logo_dark from "../media/artemis_logo_dark.png";
import artemis_logo_light from "../media/artemis_logo_light.png";

import NavItems from "./NavItems";
import NavDarkModeToggle from "./NavDarkModeToggle";

import { AiFillHome, AiFillInfoCircle } from "react-icons/ai";
import { RiTeamFill } from "react-icons/ri";
import { FaProjectDiagram } from "react-icons/fa";

const props = [
  { item: "HOME", icon: <AiFillHome />, route: "/" },
  { item: "SERVICES", icon: <FaProjectDiagram />, route: "/projects" },
  { item: "TEAM", icon: <RiTeamFill />, route: "/team" },
  { item: "ABOUT US", icon: <AiFillInfoCircle />, route: "/about" },
];

function Navbar({ darkMode, setDarkMode }) {
  return (
    <>
      <div className="navigation">
        <div className="navigation__inner">
          <div className="nav__logo">
            <Link to="/">
              <img
                src={
                  darkMode === "dark" ? artemis_logo_dark : artemis_logo_light
                }
                alt=""
              />
            </Link>
          </div>

          {props.map((prop) => {
            return <NavItems key={prop.item} prop={prop} darkMode={darkMode} />;
          })}

          <NavDarkModeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
        </div>
      </div>
    </>
  );
}

export default Navbar;
